import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectSaleInvoiceInstalmentTables } from 'store/saleInvoices/services/getProjectSaleInvoiceInstalmentTables';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

export const loadProjectInstalmentTables = createAsyncThunk(
  'saleInvoices/loadProjectInstalmentTables',
  async (_, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const instalmentTables = await getProjectSaleInvoiceInstalmentTables(
      selectedProjectId
    );

    return instalmentTables;
  }
);
